import { useSeo } from "@/components/Layout";
import { RevealLines } from "@/components/motion-primitives";
import { SectionLabel } from "@/components/ui-blocks";
import { SITE } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

const Wrapper = ({ label, title, children }) => (
  <div className="max-w-8xl mx-auto px-6 lg:px-12 pt-36 lg:pt-44 pb-24">
    <SectionLabel>{label}</SectionLabel>
    <RevealLines as="h1" delay={0.15} className="mt-6 font-display font-black uppercase tracking-tighter leading-[0.9] text-ink text-4xl sm:text-5xl lg:text-7xl" lines={[title]} />
    <div className="mt-12 max-w-3xl space-y-8 text-muted-foreground leading-relaxed">{children}</div>
  </div>
);

const Block = ({ h, children }) => (
  <section>
    <h2 className="font-display text-xl lg:text-2xl font-semibold text-ink mb-3">{h}</h2>
    {children}
  </section>
);

export function MentionsLegales() {
  const { t } = useLang();
  const g = t.legal;
  useSeo(g.mentionsSeoTitle, g.mentionsSeoDesc);
  return (
    <div data-testid="mentions-legales-page">
      <Wrapper label={g.mentionsLabel} title={g.mentionsTitle}>
        {g.mentions.map((b, i) => (
          <Block key={i} h={b.h}>
            <p>{b.p}</p>
            {b.p2 && <p className="mt-2 text-sm">{b.p2}</p>}
          </Block>
        ))}
      </Wrapper>
    </div>
  );
}

export function Confidentialite() {
  const { t } = useLang();
  const g = t.legal;
  useSeo(g.privacySeoTitle, g.privacySeoDesc);
  return (
    <div data-testid="confidentialite-page">
      <Wrapper label={g.privacyLabel} title={g.privacyTitle}>
        {g.privacy.map((b, i) => (
          <Block key={i} h={b.h}>
            <p>{b.p.replace("{email}", SITE.email)}</p>
          </Block>
        ))}
      </Wrapper>
    </div>
  );
}
